"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var regeneratePlaylist_1 = __importDefault(require("./regeneratePlaylist"));
var playlist_1 = require("../../selectors/playlist");
var generation_1 = require("../../selectors/generation");
function checkIsRegenerationRequired() {
    var action = function (dispatch, getState) {
        var shouldRegenerate = selector(getState());
        if (shouldRegenerate) {
            dispatch((0, regeneratePlaylist_1.default)());
        }
    };
    action.type = checkIsRegenerationRequired.type;
    return action;
}
function selector(state) {
    var inSafeZone = (0, playlist_1.selectSafeSwitchZone)(state);
    var regenerationRequired = (0, generation_1.selectIsRegenerationRequired)(state);
    return inSafeZone && regenerationRequired;
}
checkIsRegenerationRequired.type = "checkRegenerationRequired";
exports.default = checkIsRegenerationRequired;
//# sourceMappingURL=checkIsRegenerationRequired.js.map